export default __webpack_public_path__ + "static/media/regulatory--roundabout--g1.8433aefc.png";